import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators'
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
 
  constructor(private auth:AuthService,private router:Router){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
   // return this.auth.isLoggedIn;
   if(this.auth.isLoggedIn){
     return true
   }
   return this.auth.validateUser().pipe(map((res:any)=>{
     console.log(res)
          if(res.Status=="Success"){
            this.auth.setLoggedIn(true,JSON.parse(localStorage.getItem('token')));
            return true
          }else{
            localStorage.removeItem('loggedIn')
            localStorage.removeItem('token')
            this.router.navigate(['/login'])
            return false
          }
   }))

  }
}
